import React from 'react';
import noop from 'lodash/noop';
import { Text } from '@atlaskit/primitives';
import { FormattedMessage, useIntl } from '@atlassian/jira-intl';
import { JiraSpotlight } from '@atlassian/jira-spotlight/src/ui/jira-spotlight.tsx';
import { messages } from './messages.tsx';

type SpotlightProps = {
	onClose: () => void;
	// eslint-disable-next-line jira/react/handler-naming
	stop: () => void;
};

export const StarredSectionSpotlight = (props: SpotlightProps) => {
	const { formatMessage } = useIntl();

	const onClose = () => {
		props.stop && props.stop();
		props.onClose();
	};

	const fieldI18nValues = {
		starred: <Text as="strong">{formatMessage(messages.starred)}</Text>,
	};

	return (
		<JiraSpotlight
			actions={[
				{
					onClick: onClose,
					text: formatMessage(messages.actionText),
				},
			]}
			dialogPlacement="right top"
			heading={formatMessage(messages.title)}
			target="starred-queues"
			targetRadius={3}
			messageId="navigation-apps-sidebar-servicedesk.common.ui.practice-queues.starred-section.onboarding.spotlight.jira-spotlight.starred-queues"
			messageType="engagement"
		>
			<Text as="p">
				<FormattedMessage {...messages.description} values={fieldI18nValues} />
			</Text>
		</JiraSpotlight>
	);
};

StarredSectionSpotlight.defaultProps = {
	stop: noop,
};
